import { render } from "./Address.vue?vue&type=template&id=7c8901f6&scoped=true&ts=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"

import "./Address.vue?vue&type=style&index=0&id=7c8901f6&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c8901f6"]])

export default __exports__